import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlay, FaChevronDown, FaShieldAlt, FaMicrochip, FaCamera } from 'react-icons/fa';
import useScrollAnimation from './useScrollAnimation';

const HeroSection = () => {
  // Animation hook for the hero content container
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  return (
    <section 
      ref={sectionRef} 
      className={`hero-apple-section ${isVisible ? 'hero-in-view' : ''}`}
      id="hero"
    >
      {/* Ambient glowing spotlight behind the device */}
      <div className="hero-ambient-glow" />
      <div className="hero-radial-beam" />

      {/* Background Media Container */}
      <div className="hero-media-wrapper">
        <video
          className={`hero-bg-video ${isVideoLoaded ? 'loaded' : ''}`}
          autoPlay
          loop
          muted
          playsInline
          onLoadedData={() => setIsVideoLoaded(true)}
          poster="/Photo/i7 air 2.jpg"
        >
          <source src="/videos/hero.mp4" type="video/mp4" />
          {/* Fallback image if video not supported or fails */}
          <img 
            src="/Photo/i7 air 2.jpg" 
            alt="Peace i17 Air Flagship" 
            className="hero-fallback-img"
          />
        </video>
        <div className="hero-media-overlay" />
      </div>

      {/* Main Hero Foreground Content */}
      <div className="hero-container">
        {/* Flagship Product Category Pill */}
        <div className="hero-badge animate-item" style={{ animationDelay: '0.1s' }}>
          <span className="badge-pulse" />
          <span>New Flagship Series</span>
        </div>

        {/* Product Title with Titanium Metallic Gradient */}
        <h1 className="hero-title animate-item" style={{ animationDelay: '0.25s' }}>
          Peace i17 Air
        </h1>

        {/* Subtitle */}
        <p className="hero-tagline animate-item" style={{ animationDelay: '0.4s' }}>
          Titanium. So strong. So light. So Pro.
        </p>

        {/* Price Tagline & Availability */}
        <p className="hero-pricing animate-item" style={{ animationDelay: '0.5s' }}>
          From $999 or $41.62/mo. for 24 mo. with instant trade-in savings.
        </p>

        {/* Action Buttons */}
        <div className="hero-actions animate-item" style={{ animationDelay: '0.6s' }}>
          <Link to="/products" className="apple-btn apple-btn-primary">
            Buy Now
          </Link>
          <button 
            type="button" 
            onClick={() => setShowVideoModal(true)} 
            className="apple-btn apple-btn-secondary"
            aria-label="Watch the launch film"
          >
            <FaPlay className="btn-icon" /> Watch the film
          </button>
        </div>

        {/* Key Specification Micro Badges */}
        <div className="hero-highlights-strip animate-item" style={{ animationDelay: '0.75s' }}>
          <div className="highlight-pill">
            <FaShieldAlt className="pill-icon" />
            <span>Grade 5 Titanium</span>
          </div>
          <div className="highlight-pill">
            <FaMicrochip className="pill-icon" />
            <span>A17 Pro Bionic</span>
          </div>
          <div className="highlight-pill">
            <FaCamera className="pill-icon" />
            <span>48MP Photonic</span>
          </div>
        </div>

        {/* Centered Floating Device Preview with Zoom Animation */}
        <div className="hero-device-showcase animate-item" style={{ animationDelay: '0.85s' }}>
          <div className="device-frame-glow">
            <img 
              src="/Photo/i7 air 2.jpg" 
              alt="Peace i17 Air Titanium" 
              className="hero-main-device-img"
              loading="eager"
            />
          </div>
        </div>

        {/* Scroll Indicator prompt */}
        <a href="#highlights" className="hero-scroll-indicator" aria-label="Scroll to highlights">
          <span className="scroll-text">Scroll to explore</span>
          <FaChevronDown className="scroll-arrow" />
        </a>
      </div>

      {/* Video Modal Player */}
      {showVideoModal && (
        <div className="apple-modal-backdrop" onClick={() => setShowVideoModal(false)}>
          <div className="apple-modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="modal-close-btn" 
              onClick={() => setShowVideoModal(false)}
              aria-label="Close modal"
            >
              &times;
            </button>
            <div className="video-responsive-box">
              <video controls autoPlay playsInline className="modal-video-element">
                <source src="/videos/hero.mp4" type="video/mp4" />
                Your browser does not support HTML5 video.
              </video>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroSection;
